module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-6 is-offset-3"
  }, [_c('admin-form', {
    attrs: {
      "create": true
    },
    on: {
      "saved": _vm.onSave
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-79dc30c3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/src/views/admins/AdminCreate.vue
// module id = 561
// module chunks = 0